import { connect } from "react-redux";
import {
  projects,
  projectsLoading,
  projectLoading,
  projectPagination,
  projectPrograms,
  resources,
  project,
  getError,
} from "../../../store/selectors/projects.selector";
import { clients } from "../../../store/selectors/clients.selector";
import {
  getProjects,
  createProjectRequest,
  deleteProjectRequest,
  updateProjectRequest,
  getPrograms,
  getResourcesRequest,
  getProjectDetails,
} from "../../../store/actions/projects.actions";
import { users } from "../../../store/selectors/user.selector";
import { getUsers } from "../../../store/actions/user.actions";
import { getClients } from "../../../store/actions/clients.actions";
import Projects from "./Projects";
const mapDispatchToProps = {
  getProjectsRequest: getProjects,
  getUsersRequest: getUsers,
  createProjectRequest,
  deleteProjectRequest,
  updateProjectRequest,
  getPrograms,
  getClients,
  getResourcesRequest,
  getProjectDetails,
};

const mapStateToProps = (state) => {
  return {
    allUsers: users(state),
    allProjects: projects(state),
    pagination: projectPagination(state),
    pageLoading: projectsLoading(state),
    loading: projectLoading(state),
    allclients: clients(state),
    allprograms: projectPrograms(state),
    allresources: resources(state),
    projectDetails: project(state),
    error: getError(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Projects);
